import React from 'react'
import PropTypes from 'prop-types'

import styles from './styles'

function NegativeMediaAnswer(props) {
  const { questionData } = props
  const answers = questionData?.answer?.answer_object
  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Mídia Negativa</h2>
      <div className={classes.formWrapper}>
        <h3>Pergunta:</h3>
        <p>{questionData.text}</p>

        {answers && (
          <React.Fragment>
            <h3>Resposta:</h3>
            <div className={classes.subject}>
              <p>
                <span>
                  Os fatos noticiados{' '}
                  <a
                    href={questionData.occurrence.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    nesta midia negativa
                  </a>{' '}
                  estão relacionados com você:
                </span>{' '}
                {answers.related ? 'sim' : 'não'}
              </p>
              <p>
                <span>Resumo da ocorrencia: </span>
                {answers.occurrence_summary}
              </p>
              {answers.adopted_approaches ? (
                <p>
                  <span>Tratativas adotadas:</span> {answers.adopted_approaches}
                </p>
              ) : null}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

NegativeMediaAnswer.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default NegativeMediaAnswer
